import { render, staticRenderFns } from "./RoutineDetailsTable.vue?vue&type=template&id=2c8e4e56"
import script from "./RoutineDetailsTable.vue?vue&type=script&lang=js"
export * from "./RoutineDetailsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports